import { Flex, HStack, Icon, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiCheckSquare, FiFile, FiFolder } from "react-icons/fi";
import type { BuyerPublicBidDetailDto } from "../../../../autogen/bff-api";
import { DocumentsAsOwnerTable } from "../../../../common/documents/DocumentsAsOwnerTable";
import { DownloadDocumentIconButton } from "../../../../common/documents/DownloadDocumentIconButton/DownloadDocumentIconButton";
import { SectionCard } from "../../../sourcing-events/portal/view-single/SectionCard";

interface Props {
  detail: BuyerPublicBidDetailDto;
}

export const DocumentsTab = ({ detail }: Props) => {
  const { t } = useTranslation();
  const { bid } = detail;
  return (
    <Stack spacing="6">
      {bid.signedDocumentId && (
        <SectionCard icon={FiCheckSquare} title={t("Signed offer")}>
          <Flex
            align="center"
            justify="space-between"
            border="1px solid"
            borderColor="smBorder"
            rounded="md"
            px="4"
            py="3"
          >
            <HStack spacing="3">
              <Icon as={FiFile} color="smPrimary" boxSize="5" />
              <Text fontSize="sm" color="smText">
                {t("Digitally signed offer document")}
              </Text>
            </HStack>
            <DownloadDocumentIconButton documentId={bid.signedDocumentId} isSignedDocument size="sm" />
          </Flex>
        </SectionCard>
      )}
      <SectionCard icon={FiFolder} title={t("Offer documents")}>
        <DocumentsAsOwnerTable documents={bid.documents ?? []} />
      </SectionCard>
    </Stack>
  );
};
